import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { PreUserRepository } from "../domain/PreUserRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { PreUserValidate } from "../domain/PreUserValidate";


export function createApiPreUserRepository(): PreUserRepository {
  return new ApiPreUserRepository();
}

export class ApiPreUserRepository
  extends APIRepository
  implements PreUserRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  resendCode(): Promise<void> {
    console.log("call resendCode");
    try {
      return this.doPostNew("/api/welcome/resendCode", null, {});
    } catch (error) {
      console.log("error resendCode:" + error);
      throw error;
    }
  }

 async createUser(email: string, password: string): Promise<void> {

const resp = await this.doPostNoAuth("/api/preusers/create", null, {
  user: {
    email: email,
    password: password
  }
});

console.log("ret resp:" + JSON.stringify(resp));

// Narrow resp to expected type
const response = resp as { code?: number; message?: string };

// Si la respuesta indica un error, lanza un error para que el 'catch' lo maneje
if (response.code === 5001) {
  throw new Error(response.message);
} else if (response.code === 5002) {
  // TODO: llamar a un metodo en que le indique por correo al usaurio si quiere recuperar su contraseña
  console.log("mensaje 5002");
  throw new Error(response.message);
} else {
  // Si todo está bien, no necesitas hacer nada, la Promise de la función async
  // se resolverá implícitamente porque no se lanzó ningún error.
  // Opcional: podrías devolver 'resp' si la promesa debería resolverse con un valor.
  // En tu caso, es Promise<void>, así que no necesitas un 'return' explícito para la resolución exitosa.
}
  } catch (error: any) {
    // Este 'catch' atrapará cualquier error lanzado dentro del 'try' block,
    // incluyendo los 'throw new Error()' que agregamos.
    console.log("error Api Repository: " + error.message || error);
    // Vuelve a lanzar el error para que la función que llama a createAnimal
    // pueda manejarlo con su propio .catch() o try...catch.
    throw error;
  }

  

  validateCode(preUserValidate: PreUserValidate): Promise<void> {
    //console.log("call validateCode", JSON.stringify(preUserValidate));
    try {
      return this.doPostNew("/api/welcome/validateCode", null, {
        ...preUserValidate,
        code: preUserValidate.code,
      });
    } catch (error) {
      //console.log("error validateCode:" + error);
      return Promise.reject();
    }
  }

  completeUserPhone(phone: string, countryCode:string): Promise<void>{
    console.log("(ApiPreUserRepository) call completeUser", JSON.stringify(phone));
    try {
      return this.doPostNew("/api/welcome/completeUserPhone", null, {
        phone: phone,
        countryCode: countryCode
      });
    } catch (error) {
      console.log("(ApiPreUserRepository) error completeUserPhone:" + error);
      return Promise.reject();
    }
  }

  keepContact(country: string, otherCountry:string): Promise<void>{
    console.log("(ApiPreUserRepository) keepContact:"  + JSON.stringify(country) + " - " + JSON.stringify(otherCountry));
    try {
      return this.doPostNew("/api/welcome/keepContact", null, {
        country: country,
        otherCountry: otherCountry
      });
    } catch (error) {
      console.log("(ApiPreUserRepository) error keepContact:" + error);
      return Promise.reject();
    }
  }

  completeUser(firstName: string, lastName: string, gen: string, country:string): Promise<void> {
    console.log("call completeUser", JSON.stringify(firstName), JSON.stringify(lastName), JSON.stringify(gen), JSON.stringify(country));
    try {
      return this.doPostNew("/api/welcome/completeUser", null, {
        firstName: firstName,
        lastName: lastName,
        gen: gen,
        country: country
      });
    } catch (error) {
      console.log("error completeUser:" + error);
      return Promise.reject();
    }
  }

  async validateUser(): Promise<PreUserValidate> {
    //console.log("call validateUser");
    try {
      const myPreUserValidate = await this.doGet<PreUserValidate>("/api/welcome/validateUser");
      console.log("(ApiPreUserRepository) myPreUserValidate:", JSON.stringify(myPreUserValidate));
      return myPreUserValidate;

    } catch (error: any) {
      //console.log("***********error validateUser:" + JSON.stringify(error));
      if (error?.type === "PreUserIsValidatedError") {
        console.log("error validateUser (PreUserIsValidatedError):" + JSON.stringify(error));
      } else {
        console.log("error validateUser:" + JSON.stringify(error));
      }

      return Promise.reject(error.message);
    }
  }



}
